import { render, staticRenderFns } from "./BaseEditBtn.vue?vue&type=template&id=2e34c755&scoped=true"
import script from "./BaseEditBtn.vue?vue&type=script&lang=js"
export * from "./BaseEditBtn.vue?vue&type=script&lang=js"
import style0 from "./BaseEditBtn.vue?vue&type=style&index=0&id=2e34c755&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e34c755",
  null
  
)

export default component.exports